import { render, staticRenderFns } from "./MapBoxKey.vue?vue&type=template&id=5520d28e&scoped=true&lang=pug&"
import script from "./MapBoxKey.vue?vue&type=script&lang=js&"
export * from "./MapBoxKey.vue?vue&type=script&lang=js&"
import style0 from "./MapBoxKey.vue?vue&type=style&index=0&id=5520d28e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5520d28e",
  null
  
)

/* custom blocks */
import block0 from "./MapBoxKey.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports